export default {
  i18n: {
    messages: {
      de: {
        detailsTitle: 'AdWords Dashboard',
      },
      en: {
        detailsTitle: 'AdWords Dashboard',
      },
    },
  },
}
